export default __webpack_public_path__ + "assets/benin-flag.png";